/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_RetryInputs */

const vi_einvoice_credential_retry = /** @type {(inputs: Einvoice_Credential_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử tải lại`)
};

/**

* @param {Einvoice_Credential_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_retry = /** @type {((inputs?: Einvoice_Credential_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_retry(inputs)
});